// 'use client';
// import { HugeiconsIcon } from '@hugeicons/react';
// import {
//   FavouriteIcon,
//   ShoppingCart01Icon,
//   UserIcon,
// } from '@hugeicons/core-free-icons';
// import { useAppSelector } from '@/lib/redux/hooks';
// import Link from 'next/link';
// import React, { useEffect, useState } from 'react';
// import { useAppDispatch } from '@/lib/redux/hooks';
// import { fetchCartItems } from '@/lib/redux/features/cart';
// import { useAuth } from '@/features/authentication/hooks/auth';
// import NextImage from '@/features/Image';
// import { useFetcherCSR } from '@/lib/useFetcherCSR';
// const HeaderCart = () => {
//   const { user } = useAuth();
//   const { data: wishlists } = useFetcherCSR(user && `/api/v2/wishlists`);
//   const [totalQuantity, setTotalQuantity] = useState(0);
//   const despatch = useAppDispatch();
//   const { items } = useAppSelector((state) => state.cart);
//   const [isCartDrawerOpen, setIsCartDrawerOpen] = useState(false);

//   useEffect(() => {
//     setTotalQuantity(items.reduce((total, item) => total + item.quantity, 0));
//   }, [items]);

//   useEffect(() => {
//     if (!user) return;
//     despatch(fetchCartItems());
//   }, [despatch, user]);

//   return (
//     <>
//       <Link
//         className="header__action-btn  d-xl-grid cart-link"
//         href="/wishlist"
//       >
//         {/* <FaRegHeart /> */}
//         <HugeiconsIcon icon={FavouriteIcon} />
//         {wishlists?.data?.length > 0 && (
//           <span className="cart-count">{wishlists?.data?.length}</span>
//         )}
//       </Link>

//       <Link className="header__action-btn d-xl-grid cart-link" href="/cart">
//         {/* <IoCartOutline /> */}
//         <HugeiconsIcon icon={ShoppingCart01Icon} />
//         {totalQuantity > 0 && (
//           <span className="cart-count">{totalQuantity}</span>
//         )}
//       </Link>

//       <Link className="header__action-btn d-xl-grid" href="/account">
//         {/* <FaRegUser /> */}
//         {user?.data?.avatar ? (
//           <div
//             className="d-inline-block rounded-circle overflow-hidden"
//             style={{ width: '26.18px', height: '26.18px' }}
//           >
//             <NextImage
//               src={user?.data?.avatar}
//               alt={'user Image'}
//               width={26.18}
//               height={26.18}
//               className="w-100 h-100 border-2"
//               style={{ objectFit: 'cover' }}
//             />
//             2222222
//           </div>
//         ) : (
//           <HugeiconsIcon icon={UserIcon} />
//         )}
//       </Link>
//     </>
//   );
// };

// export default HeaderCart;

'use client';

import { HugeiconsIcon } from '@hugeicons/react';
import {
  FavouriteIcon,
  ShoppingCart01Icon,
  UserIcon,
} from '@hugeicons/core-free-icons';
import Link from 'next/link';
import React, { MouseEvent, useEffect, useState } from 'react';
import NextImage from '@/features/Image';

// 1. Import the new components and styles
import CartDrawer from './CartDrawer';
import { useFetcherCSR } from '@/lib/useFetcherCSR';
import { useAuth } from '@/features/authentication/hooks/auth';
import { useAppDispatch, useAppSelector } from '@/lib/redux/hooks';
import { fetchCartItems } from '@/lib/redux/features/cart';

const HeaderCart: React.FC = () => {
  const { user } = useAuth();
  const { data: wishlists } = useFetcherCSR(user && `/api/v2/wishlists`);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const despatch = useAppDispatch();
  const { items } = useAppSelector((state) => state.cart);

  const [isCartDrawerOpen, setIsCartDrawerOpen] = useState(false);

  useEffect(() => {
    setTotalQuantity(items.reduce((total, item) => total + item.quantity, 0));
  }, [items]);

  useEffect(() => {
    if (!user) return;
    despatch(fetchCartItems());
  }, [despatch, user]);

  useEffect(() => {
    if (isCartDrawerOpen) {
      // 1. Calculate the width of the scrollbar
      // We do this by comparing the window's full width with the client's width (which excludes the scrollbar)
      const scrollbarWidth =
        window.innerWidth - document.documentElement.clientWidth;

      // 2. Add the 'overflow: hidden' class
      document.body.classList.add('cart-drawer-is-open');

      // 3. Apply the scrollbar's width as padding to the body
      // This prevents the page content from jumping to the right
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    } else {
      // When the drawer closes, remove the class and the padding
      document.body.classList.remove('cart-drawer-is-open');
      document.body.style.paddingRight = ''; // Reset the padding
    }

    // Cleanup function to ensure styles are removed if the component unmounts
    return () => {
      document.body.classList.remove('cart-drawer-is-open');
      document.body.style.paddingRight = '';
    };
  }, [isCartDrawerOpen]);

  const handleCartClick = (e: MouseEvent<HTMLAnchorElement>) => {
    // Prevent the link from navigating to a new page
    e.preventDefault();
    // Open the drawer instead
    setIsCartDrawerOpen(true);
  };
  const wishlistsLength = wishlists?.data?.length || 0; // Static value
  return (
    <>
      {/* Wishlist Icon */}
      <Link
        className="header__action-btn  d-xl-grid cart-link"
        href="/wishlist"
      >
        <HugeiconsIcon icon={FavouriteIcon} />
        {wishlistsLength > 0 && (
          <span className="cart-count">{wishlistsLength}</span>
        )}
      </Link>

      <Link
        href="/cart"
        className="header__action-btn d-xl-grid cart-link"
        onClick={handleCartClick}
        aria-label="Open shopping cart"
      >
        <HugeiconsIcon icon={ShoppingCart01Icon} />
        {totalQuantity > 0 && (
          <span className="cart-count">{totalQuantity}</span>
        )}
      </Link>

      {/* User Icon */}
      <Link className="header__action-btn d-xl-grid" href="/account">
        {user?.data?.avatar ? (
          <div
            className="d-inline-block rounded-circle overflow-hidden"
            style={{ width: '26.18px', height: '26.18px' }}
          >
            <NextImage
              src={user.data.avatar}
              alt={'user Image'}
              width={26.18}
              height={26.18}
              className="w-100 h-100 border-2"
              style={{ objectFit: 'cover' }}
            />
          </div>
        ) : (
          <HugeiconsIcon icon={UserIcon} />
        )}
      </Link>

      {/* 4. Render the CartDrawer component */}
      <CartDrawer
        isOpen={isCartDrawerOpen}
        onClose={() => setIsCartDrawerOpen(false)}
      />
    </>
  );
};

export default HeaderCart;
